import toastrjs from 'siiimple-toast/src/main';

function parseDuration(duration) {
    return duration === false ? 9999999 : duration
}

const toast = {
    success(message, duration = 10000) {
        toastrjs.success(message, {
            duration: parseDuration(duration)
        });
    },

    error(message, duration = 10000) {
        toastrjs.alert(message, {
            duration: parseDuration(duration)
        });
    },

    info(message, duration = 10000) {
        toastrjs.message(message, {
            duration: parseDuration(duration)
        });
    },
};

export {
    toast
}
